<mat-card appearance="outlined" class="m-x-3 m-y-3">

  <mat-card-header>
    <mat-card-title class="text-danger">{{ 'APP_ERRORS.SYSTEM_ERROR_TITLE' | translate }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="mt-3">
    <p>{{ 'APP_ERRORS.SYSTEM_ERROR' | translate }}</p>
    @if (error) {
      <div>
        <h5>
          {{ 'ERROR' | translate }}:
        </h5>
        @if (error.name) {
          <div>
            <p>{{error.name}} {{error.message}}</p>
          </div>
        }
        @if (error.status) {
          <div>
            <p>{{error.status}} {{error.statusText}}</p>
          </div>
        }
        @if (error.stack) {
          <div>
            <h5>Stack:</h5>
            <code>{{error.stack}}</code>
          </div>
        }
        @if (!error.stack) {
          <div>
            <h5>Error dump:</h5>
            <code>{{error | json}}</code>
          </div>
        }
      </div>
    }
  </mat-card-content>

  <mat-card-actions align="end">
    @if (error) {
      <button mat-icon-button type="button" matTooltip="{{ 'app-error-page.component.copia-errore' | translate }}" [matTooltipPosition]="'below'"
        [cdkCopyToClipboard]="rawError" class="btnClipboard">
        <mat-icon>content_copy</mat-icon>
      </button>
    }
  </mat-card-actions>
</mat-card>